// ─────────────────────────────────────────────────────────────────────────────
// Mock Employee / Staff Data — matches shape of API_PATHS.STAFF_LIST response
// Used in: EmployeeList.jsx, Dashboard.jsx (Team Members section)
// ─────────────────────────────────────────────────────────────────────────────

export const mockEmployeeListResponse = {
  rescode: 1,
  message: "Staff list fetched successfully",
  data: {
    userCount: 6,
    users: [
      {
        UserId: 201,
        FirstName: "Dr. Neha",
        LastName: "Agarwal",
        Phone: "9876501234",
        Email: "neha.agarwal@jcdc.in",
        address: "8, Lal Kothi, Jaipur, Rajasthan",
        gender: "Female",
        dob: "1988-05-20",
        joining_date: "2021-06-01",
        designation: "Doctor",
        is_doctor: 1,
        is_billable: 1,
        short_biography:
          "Specialist in pediatric speech therapy with 10+ years of experience.",
        IsActive: 1,
        Image: null,
        session: [
          { session_name: "Evaluation", fee: 1500, session_type_id: 1 },
          { session_name: "Regular", fee: 800, session_type_id: 2 },
          { session_name: "MTS", fee: 1200, session_type_id: 3 },
          { session_name: "TFS", fee: 1000, session_type_id: 4 },
          { session_name: "MWFS", fee: 950, session_type_id: 5 },
          { session_name: "Group", fee: 600, session_type_id: 6 },
          { session_name: "Follow-Up", fee: 500, session_type_id: 7 },
        ],
      },
      {
        UserId: 202,
        FirstName: "Rahul",
        LastName: "Meena",
        Phone: "9811223344",
        Email: "rahul.meena@jcdc.in",
        address: "15, Bani Park, Jaipur, Rajasthan",
        gender: "Male",
        dob: "1992-09-14",
        joining_date: "2022-03-15",
        designation: "Doctor",
        is_doctor: 1,
        is_billable: 1,
        short_biography:
          "Occupational therapist focused on sensory integration and fine motor skills.",
        IsActive: 1,
        Image: null,
        session: [
          { session_name: "Evaluation", fee: 1200, session_type_id: 1 },
          { session_name: "Regular", fee: 700, session_type_id: 2 },
          { session_name: "MTS", fee: 1000, session_type_id: 3 },
          { session_name: "TFS", fee: 900, session_type_id: 4 },
          { session_name: "MWFS", fee: 850, session_type_id: 5 },
          { session_name: "Group", fee: 550, session_type_id: 6 },
          { session_name: "Follow-Up", fee: 450, session_type_id: 7 },
        ],
      },
      {
        UserId: 203,
        FirstName: "Sunita",
        LastName: "Choudhary",
        Phone: "9944556677",
        Email: "sunita.choudhary@jcdc.in",
        address: "30, Adarsh Nagar, Jaipur, Rajasthan",
        gender: "Female",
        dob: "1990-02-28",
        joining_date: "2022-08-01",
        designation: "NURSE",
        is_doctor: 0,
        is_billable: 0,
        short_biography:
          "Experienced nurse providing care and assistance during therapy sessions.",
        IsActive: 1,
        Image: null,
        session: [],
      },
      {
        UserId: 204,
        FirstName: "Dr. Amit",
        LastName: "Trivedi",
        Phone: "9765432109",
        Email: "amit.trivedi@jcdc.in",
        address: "67, Raja Park, Jaipur, Rajasthan",
        gender: "Male",
        dob: "1985-11-10",
        joining_date: "2020-01-15",
        designation: "Doctor",
        is_doctor: 1,
        is_billable: 1,
        short_biography:
          "Physiotherapist specialising in pediatric motor rehabilitation.",
        IsActive: 1,
        Image: null,
        session: [
          { session_name: "Evaluation", fee: 1400, session_type_id: 1 },
          { session_name: "Regular", fee: 750, session_type_id: 2 },
          { session_name: "MTS", fee: 1100, session_type_id: 3 },
          { session_name: "TFS", fee: 950, session_type_id: 4 },
          { session_name: "MWFS", fee: 900, session_type_id: 5 },
          { session_name: "Group", fee: 580, session_type_id: 6 },
          { session_name: "Follow-Up", fee: 480, session_type_id: 7 },
        ],
      },
      {
        UserId: 205,
        FirstName: "Priyanka",
        LastName: "Shah",
        Phone: "9654789012",
        Email: "priyanka.shah@jcdc.in",
        address: "22, Vidhyadhar Nagar, Jaipur, Rajasthan",
        gender: "Female",
        dob: "1995-07-07",
        joining_date: "2023-04-10",
        designation: "MBBS",
        is_doctor: 0,
        is_billable: 0,
        short_biography:
          "Special education teacher with expertise in ABA therapy.",
        IsActive: 1,
        Image: null,
        session: [],
      },
      {
        UserId: 206,
        FirstName: "Vikram",
        LastName: "Khatri",
        Phone: "9512348765",
        Email: "vikram.khatri@jcdc.in",
        address: "5, Jhotwara Road, Jaipur, Rajasthan",
        gender: "Male",
        dob: "1993-03-17",
        joining_date: "2023-09-20",
        designation: "NURSE",
        is_doctor: 0,
        is_billable: 0,
        short_biography:
          "Trained nurse with background in developmental pediatrics.",
        IsActive: 0,
        Image: null,
        session: [],
      },
    ],
  },
};

// ─────────────────────────────────────────────────────────────────────────────
// Mock Employee Details — matches shape of API_PATHS.STAFF_DETAILS response
// Used in: AddEmployee.jsx (edit mode), EmployeeProfile.jsx
// ─────────────────────────────────────────────────────────────────────────────

export const mockEmployeeDetails = {
  rescode: 1,
  message: "Staff details fetched successfully",
  data: {
    UserId: 201,
    FirstName: "Dr. Neha",
    LastName: "Agarwal",
    Phone: "9876501234",
    Email: "neha.agarwal@jcdc.in",
    address: "8, Lal Kothi, Jaipur, Rajasthan",
    gender: "Female",
    dob: "1988-05-20",
    joining_date: "2021-06-01",
    designation: "Doctor",
    is_doctor: 1,
    is_billable: 1,
    short_biography:
      "Specialist in pediatric speech therapy with 10+ years of clinical experience in Jaipur.",
    IsActive: 1,
    Image: null,
    total_sessions: 145,
    today_sessions: [
      { patient_name: "Aarav Sharma", date: "2026-03-01", start_time: "09:00", end_time: "09:45" },
      { patient_name: "Meera Patel", date: "2026-03-01", start_time: "10:00", end_time: "10:45" },
      { patient_name: "Rohan Gupta", date: "2026-03-01", start_time: "11:30", end_time: "12:15" },
    ],
    last_session_today: { date: "2026-03-01", start_time: "11:30", end_time: "12:15" },
    session: [
      { session_name: "Evaluation", fee: 1500, session_type_id: 1 },
      { session_name: "Regular", fee: 800, session_type_id: 2 },
      { session_name: "MTS", fee: 1200, session_type_id: 3 },
      { session_name: "TFS", fee: 1000, session_type_id: 4 },
      { session_name: "MWFS", fee: 950, session_type_id: 5 },
      { session_name: "Group", fee: 600, session_type_id: 6 },
      { session_name: "Follow-Up", fee: 500, session_type_id: 7 },
    ],
  },
};

// ─────────────────────────────────────────────────────────────────────────────
// Mock Staff Session List — matches shape of API_PATHS.STAFF_SESSION response
// Used in: EmployeeProfile.jsx (Activity tab)
// ─────────────────────────────────────────────────────────────────────────────

export const mockStaffSessionResponse = {
  rescode: 1,
  message: "Staff sessions fetched successfully",
  data: {
    totalAppointments: 12,
    appointments: [
      { id: 301, patient_name: "Aarav Sharma", date: "2026-03-01", start_time: "09:00", end_time: "09:45", session_type: "Regular", fee_pay_type: "UPI", is_absent: 0, is_complete: 1 },
      { id: 302, patient_name: "Meera Patel", date: "2026-03-01", start_time: "10:00", end_time: "10:45", session_type: "Evaluation", fee_pay_type: "Cash", is_absent: 0, is_complete: 1 },
      { id: 303, patient_name: "Rohan Gupta", date: "2026-03-01", start_time: "11:30", end_time: "12:15", session_type: "MTS", fee_pay_type: "Card", is_absent: 0, is_complete: 0 },
      { id: 304, patient_name: "Priya Singh", date: "2026-02-28", start_time: "09:00", end_time: "09:45", session_type: "Regular", fee_pay_type: "UPI", is_absent: 0, is_complete: 1 },
      { id: 305, patient_name: "Karan Joshi", date: "2026-02-28", start_time: "10:30", end_time: "11:15", session_type: "TFS", fee_pay_type: "Cash", is_absent: 1, is_complete: 0 },
      { id: 306, patient_name: "Ananya Verma", date: "2026-02-27", start_time: "09:00", end_time: "09:45", session_type: "Regular", fee_pay_type: "UPI", is_absent: 0, is_complete: 1 },
      { id: 307, patient_name: "Aarav Sharma", date: "2026-02-27", start_time: "11:00", end_time: "11:45", session_type: "Follow-Up", fee_pay_type: "Cash", is_absent: 0, is_complete: 1 },
      { id: 308, patient_name: "Vikash Kumar", date: "2026-02-26", start_time: "09:30", end_time: "10:15", session_type: "Group", fee_pay_type: "UPI", is_absent: 0, is_complete: 1 },
      { id: 309, patient_name: "Meera Patel", date: "2026-02-25", start_time: "10:00", end_time: "10:45", session_type: "Regular", fee_pay_type: "Card", is_absent: 0, is_complete: 1 },
      { id: 310, patient_name: "Nisha Rani", date: "2026-02-24", start_time: "09:00", end_time: "09:45", session_type: "Evaluation", fee_pay_type: "Cash", is_absent: 0, is_complete: 1 },
    ],
  },
};

// ─────────────────────────────────────────────────────────────────────────────
// Mock Staff Activity Summary — matches shape of STAFF_ACTIVITY_SUMMARY
// Used in: EmployeeProfile.jsx (Activity tab — summary cards, revenue, metrics)
// ─────────────────────────────────────────────────────────────────────────────

export const mockStaffActivitySummaryResponse = {
  rescode: 1,
  message: "Activity summary fetched successfully",
  data: {
    summary: {
      totalSessions: 42,
      totalRevenue: 34600,
      uniquePatients: 18,
      attendancePercent: 94,
      presentSessions: 39,
      absentSessions: 2,
      cancelledSessions: 1,
    },
    revenueBreakdown: [
      { session_type: "Regular", sessions: 20, revenue: 16000 },
      { session_type: "Evaluation", sessions: 8, revenue: 12000 },
      { session_type: "Group", sessions: 6, revenue: 3600 },
      { session_type: "Follow-Up", sessions: 5, revenue: 2500 },
      { session_type: "MTS", sessions: 3, revenue: 500 },
    ],
    avgRevenuePerSession: 824,
    performance: {
      cancellationRate: 2,
      avgSessionsPerWeek: 10.5,
      sessionGrowth: 12,
      revenueGrowth: 8,
      prevMonthSessions: 37,
      prevMonthRevenue: 32040,
    },
    month: "03",
    year: "2026",
  },
};

// ─────────────────────────────────────────────────────────────────────────────
// Mock Staff Attendance Summary — matches shape of STAFF_ATTENDANCE_SUMMARY
// Used in: EmployeeProfile.jsx (Attendance tab — summary cards, calendar, productivity)
// ─────────────────────────────────────────────────────────────────────────────

export const mockStaffAttendanceSummaryResponse = {
  rescode: 1,
  message: "Attendance summary fetched successfully",
  data: {
    summary: {
      presentDays: 22,
      absentDays: 2,
      lateCheckins: 3,
      avgWorkingHours: 7.8,
      totalSessions: 42,
      totalRevenue: 34600,
      consistencyPercent: 92,
    },
    calendarDays: [
      { date: "2026-03-01", status: "present", sign_in: "08:55:00" },
      { date: "2026-02-28", status: "present", sign_in: "09:00:00" },
      { date: "2026-02-27", status: "present", sign_in: "09:05:00" },
      { date: "2026-02-26", status: "present", sign_in: "08:50:00" },
      { date: "2026-02-25", status: "present", sign_in: "09:00:00" },
      { date: "2026-02-24", status: "late", sign_in: "09:10:00" },
      { date: "2026-02-23", status: "weekend" },
      { date: "2026-02-22", status: "weekend" },
      { date: "2026-02-21", status: "present", sign_in: "08:45:00" },
      { date: "2026-02-20", status: "present", sign_in: "09:00:00" },
      { date: "2026-02-19", status: "present", sign_in: "08:50:00" },
      { date: "2026-02-18", status: "late", sign_in: "09:20:00" },
      { date: "2026-02-17", status: "absent" },
      { date: "2026-02-16", status: "weekend" },
      { date: "2026-02-15", status: "weekend" },
      { date: "2026-02-14", status: "present", sign_in: "08:55:00" },
      { date: "2026-02-13", status: "present", sign_in: "09:00:00" },
      { date: "2026-02-12", status: "present", sign_in: "08:48:00" },
      { date: "2026-02-11", status: "present", sign_in: "09:02:00" },
      { date: "2026-02-10", status: "late", sign_in: "09:15:00" },
      { date: "2026-02-09", status: "weekend" },
      { date: "2026-02-08", status: "weekend" },
      { date: "2026-02-07", status: "present", sign_in: "08:50:00" },
      { date: "2026-02-06", status: "present", sign_in: "09:00:00" },
      { date: "2026-02-05", status: "present", sign_in: "08:55:00" },
      { date: "2026-02-04", status: "present", sign_in: "09:00:00" },
      { date: "2026-02-03", status: "absent" },
      { date: "2026-02-02", status: "weekend" },
      { date: "2026-02-01", status: "weekend" },
    ],
    month: "03",
    year: "2026",
  },
};

// ─────────────────────────────────────────────────────────────────────────────
// Mock Member Session Rates — matches shape of MEMBER_SESSION_RATES_LIST
// Used in: AddEmployee.jsx (edit mode — fetches existing rates)
// ─────────────────────────────────────────────────────────────────────────────

export const mockMemberSessionRatesResponse = {
  rescode: 1,
  message: "Session rates fetched",
  data: {
    rates: [
      { id: 1, member_id: 201, session_type_id: 1, rate: 1500, is_active: 1, sessionType: { id: 1, title: "Evaluation", recurrence_mode: "single", is_active: 1 } },
      { id: 2, member_id: 201, session_type_id: 2, rate: 800, is_active: 1, sessionType: { id: 2, title: "Regular", recurrence_mode: "weekly", is_active: 1 } },
      { id: 3, member_id: 201, session_type_id: 3, rate: 1200, is_active: 1, sessionType: { id: 3, title: "MTS", recurrence_mode: "preset", is_active: 1 } },
      { id: 4, member_id: 201, session_type_id: 4, rate: 1000, is_active: 1, sessionType: { id: 4, title: "TFS", recurrence_mode: "preset", is_active: 1 } },
      { id: 5, member_id: 201, session_type_id: 5, rate: 950, is_active: 1, sessionType: { id: 5, title: "MWFS", recurrence_mode: "preset", is_active: 1 } },
      { id: 6, member_id: 201, session_type_id: 6, rate: 600, is_active: 1, sessionType: { id: 6, title: "Group", recurrence_mode: "single", is_active: 1 } },
      { id: 7, member_id: 201, session_type_id: 7, rate: 500, is_active: 0, sessionType: { id: 7, title: "Follow-Up", recurrence_mode: "single", is_active: 1 } },
    ],
  },
};

// ─────────────────────────────────────────────────────────────────────────────
// Mock Salary List — matches shape of API_PATHS.STAFF_SALARY_LIST response
// Used in: EditSalary.jsx, EmployeeProfile.jsx
// ─────────────────────────────────────────────────────────────────────────────

export const mockSalaryListResponse = {
  rescode: 1,
  message: "Salary list fetched successfully",
  data: {
    recordCount: 9,
    salaryRecord: [
      { id: 1, userId: 201, date: "2026-03-31", totalSalary: 48000, workingDays: 12, status: "Pending", designation: "Doctor", staff_name: "Dr. Neha Agarwal", month: "Mar" },
      { id: 2, userId: 201, date: "2026-02-28", totalSalary: 48000, workingDays: 24, status: "Paid", designation: "Doctor", staff_name: "Dr. Neha Agarwal", month: "Feb" },
      { id: 3, userId: 201, date: "2026-01-31", totalSalary: 48000, workingDays: 27, status: "Paid", designation: "Doctor", staff_name: "Dr. Neha Agarwal", month: "Jan" },
      { id: 4, userId: 201, date: "2025-12-31", totalSalary: 48000, workingDays: 26, status: "Paid", designation: "Doctor", staff_name: "Dr. Neha Agarwal", month: "Dec" },
      { id: 5, userId: 201, date: "2025-11-30", totalSalary: 48000, workingDays: 25, status: "Paid", designation: "Doctor", staff_name: "Dr. Neha Agarwal", month: "Nov" },
      { id: 6, userId: 201, date: "2025-10-31", totalSalary: 48000, workingDays: 27, status: "Paid", designation: "Doctor", staff_name: "Dr. Neha Agarwal", month: "Oct" },
      { id: 7, userId: 201, date: "2025-09-30", totalSalary: 45000, workingDays: 22, status: "Paid", designation: "Doctor", staff_name: "Dr. Neha Agarwal", month: "Sep" },
      { id: 8, userId: 201, date: "2025-08-31", totalSalary: 45000, workingDays: 26, status: "Overdue", designation: "Doctor", staff_name: "Dr. Neha Agarwal", month: "Aug" },
      { id: 9, userId: 201, date: "2025-07-31", totalSalary: 45000, workingDays: 25, status: "Paid", designation: "Doctor", staff_name: "Dr. Neha Agarwal", month: "Jul" },
    ],
  },
};

// ─────────────────────────────────────────────────────────────────────────────
// Mock Attendance List — matches shape of API_PATHS.STAFF_ATTENDANCE_LIST
// Used in: AttendanceManagement.jsx (Staff Attendance tab), EmployeeProfile.jsx
// ─────────────────────────────────────────────────────────────────────────────

export const mockAttendanceListResponse = {
  rescode: 1,
  message: "Attendance list fetched successfully",
  data: {
    attendanceCount: 14,
    attendance: [
      // Dr. Neha Agarwal (201)
      { id: 1, userId: 201, date: "2026-03-29", sign_in: "08:55:00", sign_out: "17:10:00", is_present: "Yes", total_sessions: 5, designation: "Doctor" },
      { id: 2, userId: 201, date: "2026-03-28", sign_in: "09:00:00", sign_out: "17:00:00", is_present: "Yes", total_sessions: 6, designation: "Doctor" },
      { id: 3, userId: 201, date: "2026-03-27", sign_in: "09:05:00", sign_out: "16:45:00", is_present: "Yes", total_sessions: 4, designation: "Doctor" },
      // Rahul Meena (202)
      { id: 4, userId: 202, date: "2026-03-29", sign_in: "09:10:00", sign_out: "17:20:00", is_present: "Yes", total_sessions: 4, designation: "Doctor" },
      { id: 5, userId: 202, date: "2026-03-28", sign_in: null, sign_out: null, is_present: "No", total_sessions: 0, designation: "Doctor" },
      { id: 6, userId: 202, date: "2026-03-27", sign_in: "08:50:00", sign_out: "17:30:00", is_present: "Yes", total_sessions: 5, designation: "Doctor" },
      // Priya Verma (203)
      { id: 7, userId: 203, date: "2026-03-29", sign_in: "08:45:00", sign_out: "16:50:00", is_present: "Yes", total_sessions: 6, designation: "Therapist" },
      { id: 8, userId: 203, date: "2026-03-28", sign_in: "09:15:00", sign_out: "17:00:00", is_present: "Yes", total_sessions: 5, designation: "Therapist" },
      // Anita Joshi (204) — Half Day example
      { id: 9, userId: 204, date: "2026-03-29", sign_in: "12:30:00", sign_out: "17:00:00", is_present: "Half Day", total_sessions: 2, designation: "Therapist" },
      { id: 10, userId: 204, date: "2026-03-28", sign_in: "09:00:00", sign_out: "17:00:00", is_present: "Yes", total_sessions: 3, designation: "Therapist" },
      // Vikram Singh (205)
      { id: 11, userId: 205, date: "2026-03-29", sign_in: "09:00:00", sign_out: null, is_present: "Yes", total_sessions: 2, designation: "Receptionist" },
      { id: 12, userId: 205, date: "2026-03-28", sign_in: "09:05:00", sign_out: "13:00:00", is_present: "Half Day", total_sessions: 0, designation: "Receptionist" },
      // Sonal Patel (206)
      { id: 13, userId: 206, date: "2026-03-29", sign_in: "08:50:00", sign_out: "17:15:00", is_present: "Yes", total_sessions: 4, designation: "Admin" },
      { id: 14, userId: 206, date: "2026-03-28", sign_in: null, sign_out: null, is_present: "No", total_sessions: 0, designation: "Admin" },
    ],
  },
};
